import Helpers from '../modules/Helpers'

const activeButtonClass = 'find-cottage-index__char--active'
const findCottageIndexButtons = document.getElementsByClassName('find-cottage-index__char')
const findCottageList = document.getElementsByClassName('find-cottage-index__list')

new Helpers(findCottageIndexButtons).eventListener((e) => {
    e.preventDefault()

    new Helpers(findCottageIndexButtons).removeClass(activeButtonClass)
    new Helpers(e.target).addClass(activeButtonClass)

    const char = e.target.value.toUpperCase()

    Array.from(findCottageList).forEach((ul) => {
        Array.from(ul.getElementsByTagName('li')).forEach((li) => {
            const startsWith = li.getAttribute('data-char').toUpperCase()
            const isNumeric = !isNaN(startsWith)
            const visible = char === startsWith || (char === "0-9" && isNumeric) || char === "ALL"
            li.setAttribute('aria-hidden', !visible)
        })
    })
    
})